import { render } from "./FilterStatusPoin.vue?vue&type=template&id=0c34615c"
import script from "./FilterStatusPoin.vue?vue&type=script&lang=js"
export * from "./FilterStatusPoin.vue?vue&type=script&lang=js"
script.render = render

export default script